{
	"assets": [
		{
			"id": "8",
			"layers": [
				{
					"ind": 7,
					"ty": 4,
					"parent": 6,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.224, 2.078] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [23.829, 15.536] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.2],
												[12.4, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 6, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "14",
			"layers": [
				{
					"ind": 13,
					"ty": 4,
					"parent": 12,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.224, 2.078] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [23.829, 15.536] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.2],
												[12.4, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 12, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "22",
			"layers": [
				{
					"ind": 10,
					"ty": 0,
					"parent": 5,
					"ks": {
						"a": { "a": 0, "k": [12.224, 8.078] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.224, 2.078] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 100.2, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 148.2, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 25,
					"h": 16,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "8"
				},
				{ "ind": 5, "ty": 3, "parent": 4, "ks": { "p": { "a": 0, "k": [1.35, 12.68] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 16,
					"ty": 0,
					"parent": 11,
					"ks": {
						"a": { "a": 0, "k": [12.224, 8.078] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.224, 2.078] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [60, 60], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 100.2, "s": [60, 60], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 148.2, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 25,
					"h": 16,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "14"
				},
				{ "ind": 11, "ty": 3, "parent": 4, "ks": { "p": { "a": 0, "k": [0, 7.688] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 19,
					"ty": 4,
					"parent": 18,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [7.731, 10.035] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [26.843, 31.45] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[-1.9, -9.9],
												[-4.6, 3.7]
											],
											"v": [
												[8.8, 0],
												[0.2, 12.2],
												[15.5, 17.9]
											],
											"o": [
												[0, 0],
												[1.7, 9.1],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 18,
					"ty": 3,
					"parent": 17,
					"ks": {
						"a": { "a": 0, "k": [7.731, 10.035] },
						"p": { "a": 0, "k": [7.731, 10.035] },
						"r": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [-45], "h": 1 },
								{ "t": 61.8, "s": [-45], "i": { "x": 0, "y": 1 }, "o": { "x": 0.5, "y": 0 } },
								{ "t": 151.8, "s": [0], "h": 1 },
								{ "t": 180, "s": [0], "h": 1 }
							]
						},
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 61.8, "s": [0, 0], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0.5, 0.5], "y": [0, 0] } },
								{ "t": 151.8, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 17, "ty": 3, "parent": 4, "ks": { "p": { "a": 0, "k": [3.587, 0] } }, "ip": 0, "op": 181, "st": 0 },
				{ "ind": 4, "ty": 3, "parent": 3, "ks": { "p": { "a": 0, "k": [8.574, 8.578] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 21,
					"ty": 4,
					"parent": 20,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-18.5, -1.6],
										[-0.8, -8],
										[13.2, 12.3],
										[0, 0]
									],
									"v": [
										[6.1, 32.9],
										[21.2, 0.1],
										[38.1, 16.6],
										[6.1, 32.9],
										[6.1, 32.9]
									],
									"o": [
										[-13.3, -12.5],
										[8, 0.7],
										[1.7, 17.8],
										[0, 0],
										[0, 0]
									]
								}
							}
						},
						{ "ty": "fl", "c": { "a": 0, "k": [1, 0.494, 0.114] }, "o": { "a": 0, "k": 100 } }
					]
				},
				{ "ind": 20, "ty": 3, "parent": 3, "ks": {}, "ip": 0, "op": 181, "st": 0 },
				{ "ind": 3, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "31",
			"layers": [
				{
					"ind": 30,
					"ty": 4,
					"parent": 29,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.75, 2.254] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [24.88, 15.888] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.5],
												[13.5, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 29, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "37",
			"layers": [
				{
					"ind": 36,
					"ty": 4,
					"parent": 35,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.75, 2.254] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [24.88, 15.888] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.5],
												[13.5, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 35, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "45",
			"layers": [
				{
					"ind": 33,
					"ty": 0,
					"parent": 28,
					"ks": {
						"a": { "a": 0, "k": [12.75, 8.254] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.75, 2.254] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 100.2, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 148.2, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 26,
					"h": 17,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "31"
				},
				{
					"ind": 28,
					"ty": 3,
					"parent": 27,
					"ks": { "p": { "a": 0, "k": [1.461, 13.75] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 39,
					"ty": 0,
					"parent": 34,
					"ks": {
						"a": { "a": 0, "k": [12.75, 8.254] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [0], "h": 1 },
								{ "t": 100.2, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.75, 2.254] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [60, 60], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 100.2, "s": [60, 60], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 148.2, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 26,
					"h": 17,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "37"
				},
				{ "ind": 34, "ty": 3, "parent": 27, "ks": { "p": { "a": 0, "k": [0, 8.332] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 42,
					"ty": 4,
					"parent": 41,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [8.384, 10.883] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [28.147, 33.145] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[-2, -10.8],
												[-5, 4]
											],
											"v": [
												[9.5, 0],
												[0.2, 13.2],
												[16.8, 19.4]
											],
											"o": [
												[0, 0],
												[1.9, 9.9],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 41,
					"ty": 3,
					"parent": 40,
					"ks": {
						"a": { "a": 0, "k": [8.384, 10.883] },
						"p": { "a": 0, "k": [8.384, 10.883] },
						"r": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [-45], "h": 1 },
								{ "t": 70.2, "s": [-45], "i": { "x": 0, "y": 1 }, "o": { "x": 0.5, "y": 0 } },
								{ "t": 160.2, "s": [0], "h": 1 },
								{ "t": 180, "s": [0], "h": 1 }
							]
						},
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 70.2, "s": [0, 0], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0.5, 0.5], "y": [0, 0] } },
								{ "t": 160.2, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 40, "ty": 3, "parent": 27, "ks": { "p": { "a": 0, "k": [3.895, 0] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 27,
					"ty": 3,
					"parent": 26,
					"ks": { "p": { "a": 0, "k": [6.448, 7.383] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 44,
					"ty": 4,
					"parent": 43,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-15.7, 9.9],
										[-5.4, -6],
										[17.9, 1.9]
									],
									"v": [
										[17, 37.8],
										[9.3, 2.5],
										[32.7, 5.6],
										[17, 37.8]
									],
									"o": [
										[-18.2, -1.9],
										[6.8, -4.3],
										[12.1, 13.2],
										[0, 0]
									]
								}
							}
						},
						{ "ty": "fl", "c": { "a": 0, "k": [1, 0.494, 0.114] }, "o": { "a": 0, "k": 100 } }
					]
				},
				{ "ind": 43, "ty": 3, "parent": 26, "ks": {}, "ip": 0, "op": 181, "st": 0 },
				{ "ind": 26, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "54",
			"layers": [
				{
					"ind": 53,
					"ty": 4,
					"parent": 52,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.748, 2.252] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [24.876, 15.884] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.5],
												[13.5, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 52, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "60",
			"layers": [
				{
					"ind": 59,
					"ty": 4,
					"parent": 58,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [6.748, 2.254] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [24.876, 15.888] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4.5],
												[13.5, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 58, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "68",
			"layers": [
				{
					"ind": 56,
					"ty": 0,
					"parent": 51,
					"ks": {
						"a": { "a": 0, "k": [12.748, 8.252] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 61.8, "s": [0], "h": 1 },
								{ "t": 61.8, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.748, 2.252] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 61.8, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 109.8, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 26,
					"h": 17,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "54"
				},
				{
					"ind": 51,
					"ty": 3,
					"parent": 50,
					"ks": { "p": { "a": 0, "k": [1.869, 13.348] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 62,
					"ty": 0,
					"parent": 57,
					"ks": {
						"a": { "a": 0, "k": [12.748, 8.254] },
						"o": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0], "h": 1 },
								{ "t": 61.8, "s": [0], "h": 1 },
								{ "t": 61.8, "s": [100], "h": 1 },
								{ "t": 180, "s": [100], "h": 1 }
							]
						},
						"p": { "a": 0, "k": [6.748, 2.254] },
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [60, 60], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 61.8, "s": [60, 60], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 109.8, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"w": 26,
					"h": 17,
					"ip": 0,
					"op": 181,
					"st": 0,
					"refId": "60"
				},
				{ "ind": 57, "ty": 3, "parent": 50, "ks": { "p": { "a": 0, "k": [0, 8.336] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 65,
					"ty": 4,
					"parent": 64,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [8.384, 10.883] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [28.147, 33.145] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[-2, -10.8],
												[-5, 4]
											],
											"v": [
												[9.5, 0],
												[0.2, 13.2],
												[16.8, 19.4]
											],
											"o": [
												[0, 0],
												[1.9, 9.9],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 64,
					"ty": 3,
					"parent": 63,
					"ks": {
						"a": { "a": 0, "k": [8.384, 10.883] },
						"p": { "a": 0, "k": [8.384, 10.883] },
						"r": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [-45], "h": 1 },
								{ "t": 23.4, "s": [-45], "i": { "x": 0, "y": 1 }, "o": { "x": 0.5, "y": 0 } },
								{ "t": 113.4, "s": [0], "h": 1 },
								{ "t": 180, "s": [0], "h": 1 }
							]
						},
						"s": {
							"a": 1,
							"k": [
								{ "t": 0, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 23.4, "s": [0, 0], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0.5, 0.5], "y": [0, 0] } },
								{ "t": 113.4, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
								{ "t": 180, "s": [100, 100], "h": 1 }
							]
						}
					},
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 63, "ty": 3, "parent": 50, "ks": { "p": { "a": 0, "k": [3.889, 0] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 50,
					"ty": 3,
					"parent": 49,
					"ks": { "p": { "a": 0, "k": [8.436, 8.555] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 67,
					"ty": 4,
					"parent": 66,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-19.5, -1.7],
										[-0.8, -8.5],
										[13.8, 13],
										[0, 0]
									],
									"v": [
										[6.5, 34.7],
										[22.4, 0.1],
										[40, 17.5],
										[6.5, 34.7],
										[6.5, 34.7]
									],
									"o": [
										[-14, -13.2],
										[8.4, 0.7],
										[1.8, 18.7],
										[0, 0],
										[0, 0]
									]
								}
							}
						},
						{ "ty": "fl", "c": { "a": 0, "k": [1, 0.494, 0.114] }, "o": { "a": 0, "k": 100 } }
					]
				},
				{ "ind": 66, "ty": 3, "parent": 49, "ks": {}, "ip": 0, "op": 181, "st": 0 },
				{ "ind": 49, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "95",
			"layers": [
				{
					"ind": 74,
					"ty": 4,
					"parent": 73,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [22.562, 1.4] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [56.505, 14.179] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 2.8],
												[45.1, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 73,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [35.622, 179.066] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 76,
					"ty": 4,
					"parent": 75,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [22.669, 2.803] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [56.718, 16.987] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 5.6],
												[45.3, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 75,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [41.249, 216.434] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 78,
					"ty": 4,
					"parent": 77,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [22.26, 2.803] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [55.899, 16.987] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 5.6],
												[44.5, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 77,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [38.183, 196.348] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 80,
					"ty": 4,
					"parent": 79,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [22.669, 2.803] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [56.718, 16.987] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 5.6],
												[45.3, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 79,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [32.409, 160.027] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 82,
					"ty": 4,
					"parent": 81,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [8.512, 48.271] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [28.404, 107.922] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 0],
												[17, 96.5]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 81,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [37.365, 144.836] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 84,
					"ty": 4,
					"parent": 83,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [8.6, 49.06] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [28.58, 109.5] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[17.2, 98.1],
												[0, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 83,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [57.634, 143.055] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 86,
					"ty": 4,
					"parent": 85,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [22.939, 1.98] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [57.258, 15.339] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 4],
												[28.7, 1.5],
												[45.9, 0]
											],
											"o": [
												[0, 0],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 85,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [28.956, 141.543] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 88,
					"ty": 4,
					"parent": 87,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [12.8, 55.732] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [36.981, 122.844] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[1, -11.3],
												[0, 0],
												[-6.3, -1.4],
												[0, 0],
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 0],
												[11.5, 11.8],
												[10.6, 21.5],
												[23.8, 8.3],
												[17.8, 28.1],
												[13.2, 58.6],
												[25.6, 111.5]
											],
											"o": [
												[0, 0],
												[-1, 10.8],
												[0, 0],
												[6.3, 1.4],
												[0, 0],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 87,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [41.178, 8.289] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 90,
					"ty": 4,
					"parent": 89,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [11.814, 13.815] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [35.009, 39.01] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[-9.4, -0.2],
												[0.2, -13.8]
											],
											"v": [
												[0.2, 7],
												[7.5, 0],
												[23.6, 27.6]
											],
											"o": [
												[0, 0],
												[9.3, 0.2],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 89, "ty": 3, "parent": 72, "ks": { "p": { "a": 0, "k": [21.898, 0] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 92,
					"ty": 4,
					"parent": 91,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [18.685, 57.865] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [48.749, 127.11] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0],
												[1.5, 1.4],
												[0.5, 17.3],
												[0, 0.3],
												[-6.2, 1.1],
												[0.5, -3.2],
												[-0.8, -1.7],
												[-3.5, 2],
												[4.9, 4.4],
												[-3.5, 6],
												[-2.3, -17.7]
											],
											"v": [
												[30.2, 115.7],
												[22.5, 67.7],
												[19.8, 62.5],
												[0, 24.9],
												[0, 24.1],
												[7.3, 9.5],
												[11.7, 18.3],
												[12.4, 23.7],
												[18.8, 25.3],
												[18, 11.6],
												[12.5, 2.4],
												[37.4, 19.3]
											],
											"o": [
												[0, 0],
												[-0.3, -2],
												[-5.5, -5.3],
												[0, -0.3],
												[0.1, -2.4],
												[5.3, -0.9],
												[-0.3, 1.8],
												[1, 2],
												[6.6, -3.9],
												[-2, -1.8],
												[3.5, -6],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 91, "ty": 3, "parent": 72, "ks": { "p": { "a": 0, "k": [0, 6.965] } }, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 94,
					"ty": 4,
					"parent": 93,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [31.762, 61.327] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [74.903, 134.035] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[0, 0],
												[0, 0],
												[0, 0],
												[16.5, -0.7],
												[0, 0],
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 3.3],
												[45.7, 0],
												[63.5, 113.3],
												[41.7, 122.6],
												[17.9, 117.3],
												[0, 3.3],
												[0, 3.3]
											],
											"o": [
												[0, 0],
												[0, 0],
												[0, 0],
												[-16.5, 0.7],
												[0, 0],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 1,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 93,
					"ty": 3,
					"parent": 72,
					"ks": { "p": { "a": 0, "k": [25.739, 119.754] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 72, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "116",
			"layers": [
				{
					"ind": 101,
					"ty": 4,
					"parent": 100,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [27.2, 31.667] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [65.78, 74.714] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[9.1, 2.7],
												[0, 0],
												[7.5, 0.2],
												[0, 0],
												[6.5, -1.8],
												[0, 0],
												[2.9, 2.2],
												[5.3, 0.3],
												[0, 0]
											],
											"v": [
												[52.2, 63.3],
												[49.5, 18.9],
												[43.4, 29.9],
												[36, 11.5],
												[29.6, 28.1],
												[19.4, 0.2],
												[17.1, 20.9],
												[15.6, 42.2],
												[5.4, 25.3],
												[5.4, 63.3]
											],
											"o": [
												[0, 0],
												[-4.4, -1.3],
												[0, 0],
												[-7.5, -0.2],
												[-0.7, -17.1],
												[-6.5, 1.8],
												[2.4, 17.5],
												[-3.5, -2.7],
												[-12.1, -0.8],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{ "ind": 100, "ty": 3, "parent": 99, "ks": {}, "ip": 0, "op": 181, "st": 0 },
				{
					"ind": 103,
					"ty": 4,
					"parent": 102,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.631, 0.033] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.642, 11.446] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[49.3, 0],
												[0, 0.1]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 102,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.312, 164.723] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 105,
					"ty": 4,
					"parent": 104,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.631, 0.033] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.642, 11.446] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[49.3, 0],
												[0, 0.1]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 104,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.312, 127.254] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 107,
					"ty": 4,
					"parent": 106,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.561, 1.871] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.503, 15.122] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[49.1, 0],
												[0, 3.7]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 106,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.381, 142.531] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 109,
					"ty": 4,
					"parent": 108,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.561, 1.873] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.503, 15.126] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[49.1, 0],
												[0, 3.7]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 108,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.381, 115.82] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 111,
					"ty": 4,
					"parent": 110,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.631, 0] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.642, 11.38] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[49.3, 0],
												[0, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 1,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 110,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.312, 98.965] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 113,
					"ty": 4,
					"parent": 112,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [29.535, 10.448] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [70.451, 32.275] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[0, 0],
												[0.5, 7.3],
												[-10.5, 0],
												[0, 0],
												[-0.5, -4.1],
												[6.9, -0.4],
												[0, 0],
												[0, 0]
											],
											"v": [
												[5.2, 20.6],
												[0.7, 15.5],
												[8, 0],
												[52.2, 0],
												[58.1, 4.6],
												[54.5, 17.4],
												[5.2, 20.6],
												[5.2, 20.6]
											],
											"o": [
												[0, 0],
												[-0.5, -7.3],
												[0, 0],
												[0, 0],
												[0.5, 4.1],
												[-6.9, 0.4],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 1,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 112,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [0.093, 63.332] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 115,
					"ty": 4,
					"parent": 114,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [24.631, 63.71] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [60.642, 138.801] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[0, 0],
												[0, 0],
												[-17.3, 2.3],
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0]
											],
											"v": [
												[0, 3.2],
												[0, 121.5],
												[26.5, 127],
												[49.3, 120.6],
												[49.3, 0],
												[0, 3.2],
												[0, 3.2]
											],
											"o": [
												[0, 0],
												[0, 0],
												[17.3, -2.3],
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 1,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 114,
					"ty": 3,
					"parent": 99,
					"ks": { "p": { "a": 0, "k": [5.312, 80.688] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 99, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		},
		{
			"id": "129",
			"layers": [
				{
					"ind": 126,
					"ty": 4,
					"parent": 125,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [34.213, 64.565] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [79.805, 140.511] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": false,
											"i": [
												[0, 0],
												[-61.8, 22.8],
												[-0.9, -0.8],
												[15.8, -10.9],
												[-3.2, -7],
												[0, 0],
												[-3, -5.1],
												[0, 0],
												[-3, -4.5],
												[8.9, -5.1],
												[0, -60.4]
											],
											"v": [
												[0.4, 129.1],
												[53.7, 0.2],
												[57.1, 0.7],
												[43.8, 17.5],
												[65, 11.2],
												[49.7, 26.2],
												[65.7, 23.5],
												[54.5, 36.4],
												[67.8, 34.9],
												[58.2, 46.5],
												[30.8, 126.8]
											],
											"o": [
												[0, 0],
												[1.1, -0.4],
												[2, 1.6],
												[0, 0],
												[2.5, 5.4],
												[0, 0],
												[3.5, 5.8],
												[0, 0],
												[1.9, 2.9],
												[-12.6, 7.2],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 2,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 125,
					"ty": 3,
					"parent": 124,
					"ks": { "p": { "a": 0, "k": [10.661, 0] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{
					"ind": 128,
					"ty": 4,
					"parent": 127,
					"ks": {},
					"ip": 0,
					"op": 181,
					"st": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"p": { "a": 0, "k": [23.333, 62.409] },
									"r": { "a": 0, "k": 0 },
									"s": { "a": 0, "k": [58.046, 136.197] }
								},
								{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						},
						{
							"ty": "gr",
							"it": [
								{
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[0, 0],
												[-27.3, 11.3],
												[0, 1],
												[0, 0],
												[1.6, -1],
												[16.7, 4.3],
												[0.1, -1.5],
												[0, 0],
												[-0.6, -0.5],
												[0, 0]
											],
											"v": [
												[0.9, 119.2],
												[45.1, 119],
												[46.7, 116.7],
												[46.7, 2.5],
												[43, 0.3],
												[11, 2.8],
												[7.9, 5],
												[0, 117.1],
												[0.9, 119.2],
												[0.9, 119.2]
											],
											"o": [
												[3.5, 2.9],
												[0.9, -0.4],
												[0, 0],
												[0, -1.9],
												[-5, 3],
												[-1.5, -0.4],
												[0, 0],
												[-0.1, 0.8],
												[0, 0],
												[0, 0]
											]
										}
									}
								},
								{
									"ty": "st",
									"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
									"lc": 1,
									"lj": 2,
									"ml": 10,
									"o": { "a": 0, "k": 100 },
									"w": { "a": 0, "k": 1.138 }
								},
								{ "ty": "tr", "o": { "a": 0, "k": 100 } }
							]
						}
					]
				},
				{
					"ind": 127,
					"ty": 3,
					"parent": 124,
					"ks": { "p": { "a": 0, "k": [0, 126.363] } },
					"ip": 0,
					"op": 181,
					"st": 0
				},
				{ "ind": 124, "ty": 3, "ks": { "p": { "a": 0, "k": [6, 6] } }, "ip": 0, "op": 181, "st": 0 }
			]
		}
	],
	"fr": 60,
	"h": 327,
	"ip": 0,
	"layers": [
		{
			"ind": 24,
			"ty": 0,
			"parent": 2,
			"ks": {
				"a": { "a": 0, "k": [25.076, 25.114] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "h": 1 },
						{ "t": 61.8, "s": [0], "h": 1 },
						{ "t": 61.8, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": { "a": 0, "k": [19.076, 19.114] },
				"s": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 61.8, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 109.8, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [100, 100], "h": 1 }
					]
				}
			},
			"w": 45,
			"h": 45,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "22"
		},
		{ "ind": 2, "ty": 3, "parent": 1, "ks": { "p": { "a": 0, "k": [175.776, 151.961] } }, "ip": 0, "op": 181, "st": 0 },
		{
			"ind": 47,
			"ty": 0,
			"parent": 25,
			"ks": {
				"a": { "a": 0, "k": [24.997, 24.981] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "h": 1 },
						{ "t": 61.8, "s": [0], "h": 1 },
						{ "t": 61.8, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": { "a": 0, "k": [18.997, 18.981] },
				"s": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 61.8, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 109.8, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [100, 100], "h": 1 }
					]
				}
			},
			"w": 44,
			"h": 44,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "45"
		},
		{ "ind": 25, "ty": 3, "parent": 1, "ks": { "p": { "a": 0, "k": [238.753, 85.559] } }, "ip": 0, "op": 181, "st": 0 },
		{
			"ind": 70,
			"ty": 0,
			"parent": 48,
			"ks": {
				"a": { "a": 0, "k": [26.073, 26.11] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "h": 1 },
						{ "t": 23.4, "s": [0], "h": 1 },
						{ "t": 23.4, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": { "a": 0, "k": [20.073, 20.11] },
				"s": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [50, 50], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 23.4, "s": [50, 50], "i": { "x": [0, 0], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 71.4, "s": [100, 100], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [100, 100], "h": 1 }
					]
				}
			},
			"w": 47,
			"h": 47,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "68"
		},
		{ "ind": 48, "ty": 3, "parent": 1, "ks": { "p": { "a": 0, "k": [126.878, 60.277] } }, "ip": 0, "op": 181, "st": 0 },
		{
			"ind": 97,
			"ty": 0,
			"parent": 71,
			"ks": {
				"a": { "a": 0, "k": [6, 6] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "h": 1 },
						{ "t": 31.8, "s": [0], "i": { "x": 1, "y": 1 }, "o": { "x": 0, "y": 0 } },
						{ "t": 91.8, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0, 24], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 31.8, "s": [0, 24], "i": { "x": [1, 0.2], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{
							"t": 44.16,
							"s": [0, -13.248],
							"i": { "x": [1, 0.228], "y": [1, 1] },
							"o": { "x": [0, 0.156], "y": [0, 0] }
						},
						{ "t": 91.8, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [0, 0], "h": 1 }
					]
				}
			},
			"w": 101,
			"h": 255,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "95"
		},
		{ "ind": 71, "ty": 3, "parent": 1, "ks": { "p": { "a": 0, "k": [262.32, 104.16] } }, "ip": 0, "op": 181, "st": 0 },
		{
			"ind": 118,
			"ty": 0,
			"parent": 98,
			"ks": {
				"a": { "a": 0, "k": [6, 6] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "h": 1 },
						{ "t": 17.4, "s": [0], "i": { "x": 1, "y": 1 }, "o": { "x": 0, "y": 0 } },
						{ "t": 77.4, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0, 29.582], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 17.4, "s": [0, 29.582], "i": { "x": [1, 0.2], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{
							"t": 29.76,
							"s": [0, -16.329],
							"i": { "x": [1, 0.228], "y": [1, 1] },
							"o": { "x": [0, 0.156], "y": [0, 0] }
						},
						{ "t": 77.4, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [0, 0], "h": 1 }
					]
				}
			},
			"w": 71,
			"h": 220,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "116"
		},
		{
			"ind": 98,
			"ty": 3,
			"parent": 1,
			"ks": { "p": { "a": 0, "k": [198.656, 163.023] } },
			"ip": 0,
			"op": 181,
			"st": 0
		},
		{
			"ind": 120,
			"ty": 4,
			"parent": 119,
			"ks": {},
			"ip": 0,
			"op": 181,
			"st": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"p": { "a": 0, "k": [24.631, 0.035] },
							"r": { "a": 0, "k": 0 },
							"s": { "a": 0, "k": [60.642, 11.45] }
						},
						{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
						{ "ty": "tr", "o": { "a": 0, "k": 100 } }
					]
				},
				{
					"ty": "gr",
					"it": [
						{
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[0, 0],
										[0, 0]
									],
									"v": [
										[49.3, 0],
										[0, 0.1]
									],
									"o": [
										[0, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
							"lc": 2,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": { "a": 0, "k": 1.138 }
						},
						{ "ty": "tr", "o": { "a": 0, "k": 100 } }
					]
				}
			]
		},
		{
			"ind": 119,
			"ty": 3,
			"parent": 1,
			"ks": { "p": { "a": 0, "k": [203.968, 356.523] } },
			"ip": 0,
			"op": 181,
			"st": 0
		},
		{
			"ind": 122,
			"ty": 4,
			"parent": 121,
			"ks": {},
			"ip": 0,
			"op": 181,
			"st": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"p": { "a": 0, "k": [24.631, 0.035] },
							"r": { "a": 0, "k": 0 },
							"s": { "a": 0, "k": [60.642, 11.45] }
						},
						{ "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
						{ "ty": "tr", "o": { "a": 0, "k": 100 } }
					]
				},
				{
					"ty": "gr",
					"it": [
						{
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[0, 0],
										[0, 0]
									],
									"v": [
										[49.3, 0],
										[0, 0.1]
									],
									"o": [
										[0, 0],
										[0, 0]
									]
								}
							}
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.145, 0.188, 0.173] },
							"lc": 2,
							"lj": 1,
							"ml": 10,
							"o": { "a": 0, "k": 100 },
							"w": { "a": 0, "k": 1.138 }
						},
						{ "ty": "tr", "o": { "a": 0, "k": 100 } }
					]
				}
			]
		},
		{
			"ind": 121,
			"ty": 3,
			"parent": 1,
			"ks": { "p": { "a": 0, "k": [203.968, 337.336] } },
			"ip": 0,
			"op": 181,
			"st": 0
		},
		{
			"ind": 131,
			"ty": 0,
			"parent": 123,
			"ks": {
				"a": { "a": 0, "k": [6, 6] },
				"o": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0], "i": { "x": 1, "y": 1 }, "o": { "x": 0, "y": 0 } },
						{ "t": 60, "s": [100], "h": 1 },
						{ "t": 180, "s": [100], "h": 1 }
					]
				},
				"p": {
					"a": 1,
					"k": [
						{ "t": 0, "s": [0, 20], "i": { "x": [1, 0.2], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{
							"t": 12.36,
							"s": [0, -11.04],
							"i": { "x": [1, 0.228], "y": [1, 1] },
							"o": { "x": [0, 0.156], "y": [0, 0] }
						},
						{ "t": 60, "s": [0, 0], "i": { "x": [1, 1], "y": [1, 1] }, "o": { "x": [0, 0], "y": [0, 0] } },
						{ "t": 180, "s": [0, 0], "h": 1 }
					]
				}
			},
			"w": 91,
			"h": 263,
			"ip": 0,
			"op": 181,
			"st": 0,
			"refId": "129"
		},
		{ "ind": 123, "ty": 3, "parent": 1, "ks": { "p": { "a": 0, "k": [102, 93.25] } }, "ip": 0, "op": 181, "st": 0 },
		{ "ind": 1, "ty": 3, "parent": 0, "ks": {}, "ip": 0, "op": 181, "st": 0 },
		{
			"ind": 132,
			"ty": 4,
			"parent": 0,
			"ks": {},
			"ip": 0,
			"op": 181,
			"st": 0,
			"shapes": [
				{ "ty": "rc", "p": { "a": 0, "k": [210, 163.5] }, "r": { "a": 0, "k": 0 }, "s": { "a": 0, "k": [420, 327] } },
				{ "ty": "fl", "c": { "a": 0, "k": [1, 0.969, 0.929] }, "o": { "a": 0, "k": 100 } }
			]
		},
		{ "ind": 0, "ty": 3, "ks": {}, "ip": 0, "op": 181, "st": 0 }
	],
	"meta": { "g": "https://jitter.video" },
	"op": 180,
	"v": "5.7.4",
	"w": 420
}
